import script from "./ScreenshotsCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenshotsCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenshotsCarousel.vue?vue&type=style&index=0&id=0f967f82&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f967f82"]])

export default __exports__